import React from "react";
import { Link } from "react-router-dom";
import "./ProfileInfo.css";

const ProfileInfo = () => {
  return (
    <div className="text-white">
      <div className="d-flex  align-center-center">
        <div>
          <h3>Basic Information</h3>
        </div>
        <div className="ms-auto">
          <Link to='editprofile' className="edit-btn">Edit Profile</Link>
        </div>
      </div>
      <table class="table borderless text-white">
        <tbody>
          <tr>
            <td>Full Name</td>
            <td>Rashed Zaman</td>
          </tr>
          <tr>
            <td>Email</td>
            <td>Rashedzaman”gmail.com</td>
          </tr>
          <tr>
            <td>Address</td>
            <td>
              10/3, Block-D, Road-11, Razia Sultana Road, Mohammadpur,
              Dhaka-1207
            </td>
          </tr>
        </tbody>
      </table>
      <h3 className="mt-5">Account Information</h3>
      <table class="table borderless text-white">
        <tbody>
          <tr>
            <td>Username</td>
            <td>rashed.zaman</td>
          </tr>
          <tr>
            <td>Password</td>
            <td>******* </td>
            <Link className="cl-pm" to='changeinfo'>Change</Link>
          </tr>
         
        </tbody>
      </table>
    </div>
  );
};

export default ProfileInfo;
